export const FOREIGN_TRADE_BY_REGIONS = 'foreignTradeByRegions';

export const FOREIGN_TRADE_BY_REGIONS_ACTIONS_NAME = {
  searchRegionAggregated: `${FOREIGN_TRADE_BY_REGIONS}/searchRegionAggregated`,
} as const;

export const FOREIGN_TRADE_BY_REGIONS_MUTATIONS_NAME = {
  setRegionAggregated: `${FOREIGN_TRADE_BY_REGIONS}/setRegionAggregated`,
} as const;

export const FOREIGN_TRADE_BY_REGIONS_GETTERS_NAME = {
  getRegionAggregated: `${FOREIGN_TRADE_BY_REGIONS}/getRegionAggregated`,
} as const;
